import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, SlidingPanel } from 'coreOld/components';
import CompanyPartDetailsForm from 'partsOld/components/CompanyPartDetailsForm';
import PartInfo from 'partsOld/components/PartInfo';
import { IPart, IPartAutocomplete } from 'partsOld/types';

import { Wrapper } from './addCompanyPartStyle';

interface IProps {
  filter: Record<string, any>;
  value: IPartAutocomplete;
  isPanelOpen: boolean;
  setValue: Dispatch<SetStateAction<IPartAutocomplete>>;
  onClosePanel: () => void;
  onAddPart: () => void;
  part: IPart;
  isLoading?: boolean;
}

const AddCompanyPartView = ({
  value,
  setValue,
  isPanelOpen,
  onClosePanel,
  onAddPart,
  part,
  isLoading,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Button onClick={() => onAddPart()} fullHeight>
        {t('labelAddCompanyPart')}
      </Button>

      <SlidingPanel isOpen={isPanelOpen} onClosePanel={onClosePanel}>
        <PartInfo
          part={value || part}
          setSelectedPart={setValue}
          selectedPart={value}
          onAddPart={onAddPart}
        />

        <CompanyPartDetailsForm
          onClosePanel={onClosePanel}
          isLoading={isLoading}
          searchedPart={part}
          isAddMode
        />
      </SlidingPanel>
    </Wrapper>
  );
};

export default AddCompanyPartView;
